@if (!takeDataFromService) { @if (element.data | withLoading | async; as widget) {
{{ setWidget(widget.data, widget.error) }}
<div>
    <app-mdr-title
        fontSize="16"
        class="dashboard-box-title d-flex m-b-{{ marginBottomTitle }}"
        >{{ element.title }}
        @if (widget.error) {
        <span
            class="ds-icon-error_outline fs-25 error-primary m-l-8"
            style="line-height: 0.8"
        ></span>
        }
    </app-mdr-title>
    @if (widget.data?.data && !isEmptyObject(widget.data?.data) && !widget.loading &&
    calculateSeriesTotal(visiblePercentage(widget.data?.data.series))) {
    <div
        class="d-flex-center justify-center"
        id="{{ element.id }}"
    >
        <div
            class="pie-chart-container"
            [ngClass]="{
                'zoom-75': applyZoom,
                'flex-direction-column': placeLegendBottom,
                'align-center': placeLegendBottom
            }"
            [ngStyle]="{ width: mainContainerWidth }"
        >
            <div
                class="pie-chart-container"
                [ngClass]="{ 'm-t-10': placeLegendBottom }"
                [ngStyle]="{ width: pieWidthCoverage }"
            >
                @if (loadedWidget || widget.error) {
                <apx-chart
                    #pieChartRef
                    [series]="formattedDataForNullValues"
                    [chart]="pieChartOptions?.chart"
                    [responsive]="pieChartOptions?.responsive"
                    [labels]="widget.data?.data.labels"
                    [colors]="pieChartOptions?.colors"
                    [dataLabels]="pieChartOptions?.dataLabels"
                    [plotOptions]="pieChartOptions?.plotOptions"
                    [states]="pieChartOptions?.states"
                    [legend]="pieChartOptions?.legend"
                    [stroke]="pieChartOptions?.stroke"
                    [tooltip]="pieChartOptions?.tooltip"
                >
                </apx-chart>
                }
            </div>
            @if (tableLegend && !placeLegendBottom) {
            <div
                class="chart-pie-legend m-t-40"
                [ngStyle]="{ width: legendWidthCoverage }"
            >
                <app-mdr-dashboards-table
                    [isChart]="true"
                    [defaultEmptyValue]="defaultEmptyValue"
                    [legend]="true"
                    [element]="element"
                    [bulletType]="bulletType"
                    [dataSource]="calculateLegendTotal(widget.data?.data.series, element.colors, widget.data?.data.labels)"
                    [displayedColumns]="legendDisplayedColumns"
                    [parentClassName]="className"
                    [currentlyDownloading]="mdrDashboardsService.currentlyDownloading"
                    [bottomBorder]="legendBottomBorder"
                    id="{{ element.id }}_legend"
                ></app-mdr-dashboards-table>
            </div>
            } @if (tableLegend && placeLegendBottom) {
            <div
                class="chart-pie-legend-bottom"
                [ngStyle]="{ width: legendWidthCoverage }"
            >
                <app-mdr-dashboards-table
                    [isChart]="true"
                    [defaultEmptyValue]="defaultEmptyValue"
                    [legend]="true"
                    [element]="element"
                    [bulletType]="bulletType"
                    [dataSource]="calculateLegendTotal(widget.data?.data.series, element.colors, widget.data?.data.labels)"
                    [displayedColumns]="legendDisplayedColumns"
                    [parentClassName]="className"
                    [currentlyDownloading]="mdrDashboardsService.currentlyDownloading"
                    [bottomBorder]="legendBottomBorder"
                    id="{{ element.id }}_legend_bottom"
                ></app-mdr-dashboards-table>
            </div>
            }
        </div>
        @if (element.description) {
        <div class="item-description width-p-78 delimiter p-l-30">
            <h4
                class="description"
                [innerHTML]="element.description"
            ></h4>
        </div>
        }
    </div>
    } @if ((!widget.data?.data || isEmptyObject(widget.data?.data) || widget.error ||
    !calculateSeriesTotal(visiblePercentage(widget.data?.data.series))) && !widget.loading) {
    <div
        class="d-flex-center justify-center"
        id="{{ element.id }}"
    >
        <div
            class="pie-chart-container"
            [ngClass]="{
                'zoom-75': applyZoom,
                'flex-direction-column': placeLegendBottom,
                'align-center': placeLegendBottom
            }"
            [ngStyle]="{ width: mainContainerWidth }"
        >
            <div
                class="pie-chart-container m-t-10"
                id="chart"
                [ngStyle]="{ width: pieWidthCoverage }"
                [ngClass]="{ 'm-t-10': placeLegendBottom }"
            >
                @if (emptyPieChartOptions) {
                <apx-chart
                    #pieChartRef
                    [series]="element.noDataSeries"
                    [chart]="emptyPieChartOptions?.chart"
                    [responsive]="emptyPieChartOptions?.responsive"
                    [labels]="element.noDataLabels"
                    [colors]="emptyPieChartOptions?.colors"
                    [states]="emptyPieChartOptions?.states"
                    [tooltip]="emptyPieChartOptions?.tooltip"
                    [dataLabels]="emptyPieChartOptions?.dataLabels"
                    [plotOptions]="emptyPieChartOptions?.plotOptions"
                    [legend]="emptyPieChartOptions?.legend"
                    [stroke]="emptyPieChartOptions?.stroke"
                ></apx-chart>
                }
            </div>
            @if (tableLegend && !placeLegendBottom) {
            <div
                class="chart-pie-legend m-t-40"
                [ngStyle]="{ width: legendWidthCoverage }"
            >
                <app-mdr-dashboards-table
                    [isChart]="true"
                    [legend]="true"
                    [bulletType]="bulletType"
                    [defaultEmptyValue]="defaultEmptyValue"
                    [dataSource]="emptyDataSource_Legend1"
                    [displayedColumns]="legendDisplayedColumns"
                    [parentClassName]="className"
                    [bottomBorder]="false"
                ></app-mdr-dashboards-table>
            </div>
            } @if (tableLegend && placeLegendBottom) {
            <div
                class="chart-pie-legend-bottom"
                [ngStyle]="{ width: legendWidthCoverage }"
            >
                <app-mdr-dashboards-table
                    [isChart]="true"
                    [legend]="true"
                    [bulletType]="bulletType"
                    [defaultEmptyValue]="defaultEmptyValue"
                    [dataSource]="emptyDataSource_Legend1"
                    [displayedColumns]="legendDisplayedColumns"
                    [parentClassName]="className"
                    [currentlyDownloading]="mdrDashboardsService.currentlyDownloading"
                    [bottomBorder]="false"
                ></app-mdr-dashboards-table>
            </div>
            }
        </div>
        @if (element.description) {
        <div class="item-description width-p-78 delimiter p-l-30">
            <h4
                class="description"
                [innerHTML]="element.description"
            ></h4>
        </div>
        }
    </div>
    } @if (widget.loading) {
    <app-mdr-loader
        [ngClass]="widget.loading ? 'widget-empty' : 'widget-loading'"
        class="center-loader"
        [rows]="5"
        [columns]="1"
    ></app-mdr-loader>
    }
</div>
} } @if (takeDataFromService) { @if (waitingForResponse) {
<app-mdr-title
    fontSize="16"
    class="dashboard-box-title d-flex m-b-{{ marginBottomTitle }}"
    >{{ element.title }}
</app-mdr-title>
<div class="m-t-25">
    <app-mdr-loader
        [ngClass]="waitingForResponse ? 'widget-empty' : 'widget-loading'"
        class="center-loader"
        [rows]="5"
        [columns]="1"
    ></app-mdr-loader>
</div>
} @if (!waitingForResponse) { @if (loadedData | withLoading | async; as widget) {
{{ setWidget(widget.data, widget.error) }}
<div>
    <app-mdr-title
        fontSize="16"
        class="dashboard-box-title d-flex m-b-{{ marginBottomTitle }}"
        >{{ element.title }}
        @if (widget.error) {
        <span
            class="ds-icon-error_outline fs-25 error-primary m-l-8"
            style="line-height: 0.8"
        ></span>
        }
    </app-mdr-title>
    @if (widget.data?.data.endpoint_categories && !isEmptyObject(widget.data?.data.endpoint_categories) && !widget.loading &&
    calculateSeriesTotal(visiblePercentage(widget.data?.data.endpoint_categories.series))) {
    <div
        class="d-flex-center justify-center"
        id="{{ element.id }}"
    >
        <div
            class="pie-chart-container"
            [ngClass]="{
                'zoom-75': applyZoom,
                'flex-direction-column': placeLegendBottom,
                'align-center': placeLegendBottom
            }"
            [ngStyle]="{ width: mainContainerWidth }"
        >
            <div
                class="pie-chart-container"
                [ngClass]="{ 'm-t-10': placeLegendBottom }"
                [ngStyle]="{ width: pieWidthCoverage }"
            >
                @if (loadedWidget || widget.error) {
                <apx-chart
                    #pieChartRef
                    [series]="formattedDataForNullValues"
                    [chart]="pieChartOptions?.chart"
                    [responsive]="pieChartOptions?.responsive"
                    [labels]="widget.data?.data.endpoint_categories.labels"
                    [colors]="pieChartOptions?.colors"
                    [dataLabels]="pieChartOptions?.dataLabels"
                    [plotOptions]="pieChartOptions?.plotOptions"
                    [states]="pieChartOptions?.states"
                    [legend]="pieChartOptions?.legend"
                    [stroke]="pieChartOptions?.stroke"
                    [tooltip]="pieChartOptions?.tooltip"
                >
                </apx-chart>
                }
            </div>
            @if (tableLegend && !placeLegendBottom) {
            <div
                class="chart-pie-legend m-t-40"
                [ngStyle]="{ width: legendWidthCoverage }"
            >
                <app-mdr-dashboards-table
                    [isChart]="true"
                    [defaultEmptyValue]="defaultEmptyValue"
                    [legend]="true"
                    [element]="element"
                    [bulletType]="bulletType"
                    [dataSource]="
                        calculateLegendTotal(
                            widget.data?.data.endpoint_categories.series,
                            element.colors,
                            widget.data?.data.endpoint_categories.labels
                        )
                    "
                    [displayedColumns]="legendDisplayedColumns"
                    [parentClassName]="className"
                    [currentlyDownloading]="mdrDashboardsService.currentlyDownloading"
                    [bottomBorder]="legendBottomBorder"
                ></app-mdr-dashboards-table>
            </div>
            } @if (tableLegend && placeLegendBottom) {
            <div
                class="chart-pie-legend-bottom"
                [ngStyle]="{ width: legendWidthCoverage }"
            >
                <app-mdr-dashboards-table
                    [isChart]="true"
                    [defaultEmptyValue]="defaultEmptyValue"
                    [legend]="true"
                    [element]="element"
                    [bulletType]="bulletType"
                    [dataSource]="
                        calculateLegendTotal(
                            widget.data?.data.endpoint_categories.series,
                            element.colors,
                            widget.data?.data.endpoint_categories.labels
                        )
                    "
                    [displayedColumns]="legendDisplayedColumns"
                    [parentClassName]="className"
                    [currentlyDownloading]="mdrDashboardsService.currentlyDownloading"
                    [bottomBorder]="legendBottomBorder"
                ></app-mdr-dashboards-table>
            </div>
            }
        </div>
        @if (element.description) {
        <div class="item-description width-p-78 delimiter p-l-30">
            <h4
                class="description"
                [innerHTML]="element.description"
            ></h4>
        </div>
        }
    </div>
    } @if ((!widget.data?.data?.endpoint_categories || isEmptyObject(widget.data?.data.endpoint_categories) || widget.error ||
    !calculateSeriesTotal(visiblePercentage(widget.data?.data.endpoint_categories.series))) && !widget.loading) {
    <div
        class="d-flex-center justify-center"
        id="{{ element.id }}"
    >
        <div
            class="pie-chart-container"
            [ngClass]="{
                'zoom-75': applyZoom,
                'flex-direction-column': placeLegendBottom,
                'align-center': placeLegendBottom
            }"
            [ngStyle]="{ width: mainContainerWidth }"
        >
            <div
                class="pie-chart-container m-t-10"
                id="chart"
                [ngStyle]="{ width: pieWidthCoverage }"
                [ngClass]="{ 'm-t-10': placeLegendBottom }"
            >
                @if (emptyPieChartOptions) {
                <apx-chart
                    #pieChartRef
                    [series]="element.noDataSeries"
                    [chart]="emptyPieChartOptions?.chart"
                    [responsive]="emptyPieChartOptions?.responsive"
                    [labels]="element.noDataLabels"
                    [colors]="emptyPieChartOptions?.colors"
                    [states]="emptyPieChartOptions?.states"
                    [tooltip]="emptyPieChartOptions?.tooltip"
                    [dataLabels]="emptyPieChartOptions?.dataLabels"
                    [plotOptions]="emptyPieChartOptions?.plotOptions"
                    [legend]="emptyPieChartOptions?.legend"
                    [stroke]="emptyPieChartOptions?.stroke"
                ></apx-chart>
                }
            </div>
            @if (tableLegend && !placeLegendBottom) {
            <div
                class="chart-pie-legend m-t-40"
                [ngStyle]="{ width: legendWidthCoverage }"
            >
                <app-mdr-dashboards-table
                    [isChart]="true"
                    [legend]="true"
                    [bulletType]="bulletType"
                    [defaultEmptyValue]="defaultEmptyValue"
                    [dataSource]="emptyDataSource_Legend1"
                    [displayedColumns]="legendDisplayedColumns"
                    [parentClassName]="className"
                    [bottomBorder]="false"
                    id="{{ element.id }}_table_legend"
                ></app-mdr-dashboards-table>
            </div>
            } @if (tableLegend && placeLegendBottom) {
            <div
                class="chart-pie-legend-bottom"
                [ngStyle]="{ width: legendWidthCoverage }"
            >
                <app-mdr-dashboards-table
                    [isChart]="true"
                    [legend]="true"
                    [bulletType]="bulletType"
                    [defaultEmptyValue]="defaultEmptyValue"
                    [dataSource]="emptyDataSource_Legend1"
                    [displayedColumns]="legendDisplayedColumns"
                    [parentClassName]="className"
                    [currentlyDownloading]="mdrDashboardsService.currentlyDownloading"
                    [bottomBorder]="false"
                    id="{{ element.id }}_table_legend_bottom"
                ></app-mdr-dashboards-table>
            </div>
            }
        </div>
        @if (element.description) {
        <div class="item-description width-p-78 delimiter p-l-30">
            <h4
                class="description"
                [innerHTML]="element.description"
            ></h4>
        </div>
        }
    </div>
    }
</div>
} } }
